/**
 * @description 生成水印
 * */
export default function getWaterMarkCanvas(text, options) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  var canvasWidth = 400;
  var canvasHeight = 400;
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'bottom';
  ctx.globalAlpha = options.globalAlpha || 0.1;
  ctx.font = options.font || '20px Microsoft Yahei';
  ctx.translate(canvasWidth / 2, canvasHeight / 2);
  ctx.rotate(options.rotateAngle || -0.4);
  ctx.translate(-canvasWidth / 2 * 1.2, -canvasHeight / 2 * 1.2);
  var waterMarkText = [];
  var chunkWidth = options.chunkWidth || 400;
  var chunkHeight = options.chunkHeight || 120;
  var horizontalChunkCount = 0;
  var verticalChunkCount = 1;
  for (var j = 0, initY = chunkHeight / 2, indent = 0; j <= verticalChunkCount; j += 1) {
    indent = parseInt(j % 2);
    for (var i = 0, initX = chunkWidth / 2; i <= horizontalChunkCount; i += 1) {
      waterMarkText.push({
        text: text,
        x: i * chunkWidth + indent * initX,
        y: j * chunkHeight + initY
      });
    }
  }
  waterMarkText.forEach(function (item) {
    ctx.fillText(item.text, item.x, item.y);
  });
  return ctx.canvas.toDataURL();
}